class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");

    if (this.mainDetailsToggle) {
      this.content = this.mainDetailsToggle.querySelector("summary").nextElementSibling;
      this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this));
      this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.removeAttribute("open");
      this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", false);
    }
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    this.header = document.querySelector(".header-wrapper");

    if (this.mainDetailsToggle) {
      this.highlightsSlider = this.mainDetailsToggle.querySelector("glide-component");
      this.mainDetailsToggle.addEventListener("mouseenter", this.openOnMouseEnter.bind(this));
    }
    this.addEventListener("mouseleave", this.onMouseLeave.bind(this));
  }

  openOnMouseEnter() {
    if (this.mainDetailsToggle.open) return;
    this.mainDetailsToggle.open = true;
    if (this.mainDetailsToggle) this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", true);

    this.onToggle();

    if (this.highlightsSlider) {
      setTimeout(() => {
        this.highlightsSlider.init();
      }, 100);
    }
  }

  onMouseLeave() {
    this.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue("--header-bottom-position-desktop") !== "") return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);
